(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultDetailController', ResultDetailController);

    ResultDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Result', 'Revision', 'Round'];

    function ResultDetailController($scope, $rootScope, $stateParams, entity, Result, Revision, Round) {
        var vm = this;

        vm.result = entity;

        var unsubscribe = $rootScope.$on('portalApp:resultUpdate', function(event, result) {
            vm.result = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
